/**
 * GlowBadge - Renders the verification badge next to usernames.
 * "glow" = gold sparkle, "glow_pro" = pink/purple double sparkle
 */
export default function GlowBadge({ tier, size = 'sm' }) {
  if (!tier) return null;

  const sizeClass = size === 'xs' ? 'w-3.5 h-3.5' : size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const isPro = tier === 'glow_pro';

  return (
    <span
      data-testid={`glow-badge-${tier}`}
      className={`inline-flex items-center ${sizeClass}`}
      title={isPro ? 'Glow Pro Creator' : 'Glow Verified'}
    >
      {isPro ? (
        <svg viewBox="0 0 24 24" fill="none" className={sizeClass}>
          <defs>
            <linearGradient id="glowProGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ec4899" />
              <stop offset="100%" stopColor="#8b5cf6" />
            </linearGradient>
          </defs>
          <path d="M12 2L14.5 8.5L21 9.5L16 14L17.5 21L12 17.5L6.5 21L8 14L3 9.5L9.5 8.5L12 2Z" fill="url(#glowProGrad)" />
          <path d="M12 6L13.2 9.2L16.5 9.7L14 12L14.7 15.5L12 13.8L9.3 15.5L10 12L7.5 9.7L10.8 9.2L12 6Z" fill="white" fillOpacity="0.4" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" fill="none" className={sizeClass}>
          <defs>
            <linearGradient id="glowGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#f59e0b" />
              <stop offset="100%" stopColor="#ef4444" />
            </linearGradient>
          </defs>
          <path d="M12 2L14.5 8.5L21 9.5L16 14L17.5 21L12 17.5L6.5 21L8 14L3 9.5L9.5 8.5L12 2Z" fill="url(#glowGrad)" />
        </svg>
      )}
    </span>
  );
}
